var styles = {"dual-input-container":"styles_dual-input-container__25jFk col-12 mx-auto","dualInputContainer":"styles_dual-input-container__25jFk col-12 mx-auto","dual-input-wrapper":"styles_dual-input-wrapper__1AZMt clearfix","dualInputWrapper":"styles_dual-input-wrapper__1AZMt clearfix","input":"styles_input__3OGg1 col col-6"};

export default styles;
//# sourceMappingURL=styles.css.js.map
